export default function (Upload, authorizationToken) {
    return function (file, referenceNumber) {
        const url = `/api/scannedLetter/${referenceNumber}`;

        return uploadImport(url, file);
    };

    function uploadImport(url, file) {
        file.status = 'Uploading';
        file.progress = 0;

        return Upload.http({
            url,
            headers: {
                'Content-Type': file.type,
                'Content-Disposition': `attachment;filename=${ encodeURI(file.name) }`,
                'Authorization': authorizationToken
            },
            data: file
        })
        .then(() => {
            file.status = 'Completed';
            file.progress = 100;
        }, resp => {
            file.status = resp.status;
        }, evt => {
            file.progress = getPercentage(evt.loaded, evt.total);
        });
    }

    function getPercentage(progress, total) {
        return 100 * parseInt(progress, 10) / parseInt(total, 10);
    }
}



// WEBPACK FOOTER //
// ./Client/app/letter-communication/services/upload/uploadScannedLetter.js